import store from '@/store'
import {
  connectionService,
  RACE_TIMEOUT,
  GEOFENCE_CREATE_URI,
  GEOFENCE_FETCH_URI,
  GEOFENCE_FIND_URI,
  GEOFENCE_DELETE_URI,
  GEOFENCE_UPDATE_URI
} from '@leapsight/styleguide'
import { i18n } from '@leapsight/portal'

export default {
  clearGeofenceOnMap() {
    const geofence = this.getCurrentZone()
    if (Object.keys(geofence).length > 0) geofence.geofence.setMap(null)
  },
  createGeofence(geofence) {
    return new Promise((resolve, reject) => {
      const connection = store.getters['auth/connection']
      const accountId = connectionService.getAccountId()
      const args = [
        {
          // eslint-disable-next-line prettier/prettier
          account_id: accountId,
          // eslint-disable-next-line prettier/prettier
          data: geofence
        }
      ]
      const security = connectionService.createkwArgs()
      const kwArgs = {
        ...security
      }
      connection.session
        .call(GEOFENCE_CREATE_URI, args, kwArgs, {})
        .then(
          response => {
            resolve(response)
          },
          wampError => {
            reject(wampError)
          }
        )
        .catch(err => {
          console.log(err)
        })
    })
  },
  deleteGeofence(id) {
    return new Promise((resolve, reject) => {
      const connection = store.getters['auth/connection']
      const args = [id]
      const security = connectionService.createkwArgs()
      const kwArgs = {
        ...security
      }
      connection.session.call(GEOFENCE_DELETE_URI, args, kwArgs, {}).then(
        response => {
          resolve(response)
        },
        wampError => {
          reject(wampError)
        }
      )
    })
  },
  getConnection() {
    return store.getters['auth/connection']
  },
  getMap() {
    return store.getters['mapState/map']
  },
  getGeofence({ id, _p = 'id, data.geometry, data.properties.name' }) {
    return new Promise((resolve, reject) => {
      const session = store.getters['auth/session']
      const security = connectionService.createkwArgs()
      const args = id
      const kwArgs = {
        ...security,
        query_spec: {
          _p
        }
      }
      const p1 = new Promise((resolve, reject) => {
        setTimeout(reject, RACE_TIMEOUT, [])
      })
      const p2 = new Promise((resolve, reject) => {
        session
          .call(GEOFENCE_FETCH_URI, [args], kwArgs, {})
          .then(response => {
            resolve(response.args[0])
          })
          .catch(error => {
            reject(error)
          })
      })
      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getGeofences(
    { _p } = {
      _p: 'id,data.geometry.type,data.properties.name, created_by'
    }
  ) {
    const session = store.getters['auth/session']
    const security = connectionService.createkwArgs()
    const accountId = connectionService.getAccountId()
    const args = { account_id: accountId }
    const kwArgs = {
      ...security,
      query_spec: {
        _p
      }
    }
    const p1 = new Promise((resolve, reject) => {
      setTimeout(reject, RACE_TIMEOUT, [])
    })
    const p2 = new Promise((resolve, reject) => {
      session
        .call(GEOFENCE_FIND_URI, [args], kwArgs, {})
        .then(response => {
          resolve(response.args[0])
        })
        .catch(error => {
          reject(error)
        })
    })
    return Promise.race([p1, p2])
      .then(value => {
        return value
      })
      .catch(error => {
        return error
      })
  },

  geofenceType: {
    Circle: (data, map) => {
      const lat = data.geometry.coordinates[0]
      const lng = data.geometry.coordinates[1]
      const radius = data.geometry.radius

      const options = {
        map,
        center: new google.maps.LatLng(lat, lng),
        title: data.properties?.name,
        radius: radius,
        strokeColor: '#8079b7',
        strokeWeight: 2,
        strokeOpacity: 0.3,
        editable: false,
        fillColor: '#554da0',
        fillOpacity: 0.1
      }

      return new google.maps.Circle(options)
    },

    Polygon: (data, map) => {
      const coordinates = data.geometry.coordinates[0]
      const path = []
      for (let i = 0; i < coordinates.length; i++) {
        const element = coordinates[i]
        const latLng = { lng: element[0], lat: element[1] }
        path.push(latLng)
      }
      const options = {
        map,
        path: path,
        title: data.properties?.name,
        strokeColor: '#8079b7',
        fillColor: '#554da0',
        editable: false,
        strokeOpacity: 0.3,
        strokeWeight: 2,
        fillOpacity: 0.1
      }

      return new google.maps.Polygon(options)
    }
  },

  geofenceOnMap(geofences, map) {
    const bounds = new google.maps.LatLngBounds()

    geofences.forEach(geofence => {
      if (!geofence.geometry.hasOwnProperty('coordinates')) return
      const type = geofence.geometry.type
      const geofenceOnMap = this.geofenceType[type](geofence, map)

      if (type != 'Circle')
        geofenceOnMap.getPaths().forEach(function(path) {
          path.forEach(function(latlng) {
            bounds.extend(latlng)
          })
        })
      else {
        const radius = geofenceOnMap.getRadius() * Math.pow(10, -5)
        const latCir = geofenceOnMap.getCenter().lat()
        const lngCir = geofenceOnMap.getCenter().lng()
        const pointX = latCir + radius
        const pointY = lngCir + radius
        const pointZ = latCir - radius
        const pointW = lngCir - radius
        const pathsCircle = [
          { lat: pointX, lng: lngCir },
          { lat: latCir, lng: pointY },
          { lat: pointZ, lng: lngCir },
          { lat: latCir, lng: pointW }
        ]
        pathsCircle.forEach(path => {
          bounds.extend(new google.maps.LatLng(path))
        })
      }

      map.fitBounds(bounds)

      geofenceOnMap.addListener('mouseover', () => {
        geofenceOnMap.setOptions({
          strokeColor: '#554da0',
          strokeOpacity: 1
        })

        map.getDiv().setAttribute('title', geofenceOnMap.get('title'))
      })

      geofenceOnMap.addListener('mouseout', () => {
        geofenceOnMap.setOptions({
          strokeColor: '#8079b7',
          strokeOpacity: 0.3
        })

        map.getDiv().removeAttribute('title')
      })

      store.dispatch('saveGeofenceOnMap', { geofenceOnMap })
    })
  },

  updateCircle(geofence) {
    return new Promise((resolve, reject) => {
      const connection = this.getConnection()
      const security = connectionService.createkwArgs()
      const args = [
        geofence.id,
        [
          {
            action: 'update',
            path: '/data/geometry',
            value: {
              coordinates: [
                geofence.geometry.coordinates[0],
                geofence.geometry.coordinates[1]
              ],
              radius: geofence.geometry.radius,
              type: 'Circle'
            }
          },
          {
            action: 'update',
            path: '/data/properties/name',
            value: geofence.properties.name
          }
        ]
      ]
      const kwArgs = {
        ...security
      }
      const p1 = new Promise((resolve, reject) => {
        setTimeout(reject, RACE_TIMEOUT, [])
      })
      const p2 = new Promise((resolve, reject) => {
        connection.session.call(GEOFENCE_UPDATE_URI, args, kwArgs, {}).then(
          response => {
            resolve(response.args[0])
          },
          wampError => {
            console.log(wampError)
            reject(wampError)
          }
        )
      })

      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updatePolygon(geofence) {
    return new Promise((resolve, reject) => {
      const connection = this.getConnection()
      const security = connectionService.createkwArgs()
      const args = [
        geofence.id,
        [
          {
            action: 'update',
            path: '/data/geometry',
            value: {
              coordinates: geofence.geometry.coordinates,
              type: 'Polygon'
            }
          },
          {
            action: 'update',
            path: '/data/properties/name',
            value: geofence.properties.name
          }
        ]
      ]
      const kwArgs = {
        ...security
      }
      const p1 = new Promise((resolve, reject) => {
        setTimeout(reject, RACE_TIMEOUT, [])
      })
      const p2 = new Promise((resolve, reject) => {
        connection.session.call(GEOFENCE_UPDATE_URI, args, kwArgs, {}).then(
          response => {
            resolve(response.args[0])
          },
          wampError => {
            console.log(wampError)
            reject(wampError)
          }
        )
      })

      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getCurrentZone() {
    return store.getters['mapState/currentZone']
  },
  getGeometryType(item) {
    const type = item.geometry.type.toLowerCase()
    return type
  },
  showGeofenceOnMap(data, geofencetype, editable = false) {
    const map = this.getMap()
    const currentZone = this.getCurrentZone()
    if (Object.keys(currentZone).length > 0) {
      currentZone.geofence.setMap(null)
    }
    switch (geofencetype) {
      case 'circle':
        const lat = data.geometry.coordinates[0]
        const lng = data.geometry.coordinates[1]
        const radius = data.geometry.radius
        const circle = new google.maps.Circle({
          map,
          center: new google.maps.LatLng(lat, lng),
          radius: radius,
          strokeColor: '#8079b7',
          strokeWeight: 2,
          editable: editable,
          fillColor: '#554da0'
        })

        // este condicional hace que el mapa se acomode a la geofensa solo en el listado de geofensas, en el caso de crear una geofensa nueva el mapa no va a cambiar su zoom ni se va a acomodar por pedido de LJ.
        if (!editable) {
          map.fitBounds(circle.getBounds())
        }
        let newCurrentZone = {
          ...data,
          geofence: circle
        }
        store.dispatch('mapState/currentGeofence', newCurrentZone)
        return circle

      case 'polygon':
        const path = this._formatCoordinates(data.geometry.coordinates[0])
        const polygonOptions = {
          map,
          path: path,
          strokeColor: '#8079b7',
          fillColor: '#554da0',
          editable: editable,
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillOpacity: 0.35
        }
        const polygon = new google.maps.Polygon(polygonOptions)
        if (!editable) {
          // map.fitBounds(polygon.getBounds())
          const bounds = new google.maps.LatLngBounds()
          polygon.getPaths().forEach(function(path) {
            path.forEach(function(latlng) {
              bounds.extend(latlng)
              map.fitBounds(bounds)
            })
          })
        }

        newCurrentZone = {
          ...data,
          geofence: polygon
        }

        store.dispatch('mapState/currentGeofence', newCurrentZone)
        return polygon
    }
  },
  showPolygon() {
    const currentZone = this.getCurrentZone()
    if (Object.keys(currentZone).length > 0) {
      currentZone.circle.setMap(null)
    }

    const map = this.getMap()

    const triangleCoords = [
      { lat: 25.774, lng: -80.19 },
      { lat: 18.466, lng: -66.118 },
      { lat: 32.321, lng: -64.757 }
    ]

    const bermudaTriangle = new google.maps.Polygon({
      map,
      editable: true,
      paths: triangleCoords,
      strokeColor: '#FF0000',
      strokeOpacity: 0.8,
      strokeWeight: 3,
      fillColor: '#FF0000',
      fillOpacity: 0.35
    })

    const newCurrentZone = {
      ...data,
      bermudaTriangle
    }
    store.dispatch('mapState/currentGeofence', newCurrentZone)
    return bermudaTriangle
  },
  _formatCoordinates(coordinates) {
    const path = []
    for (let i = 0; i < coordinates.length; i++) {
      const element = coordinates[i]
      const latLng = { lng: element[0], lat: element[1] }
      path.push(latLng)
    }
    return path
  },
  //ERRORS
  getErrorMessageByCode(code = '') {
    let strToReturn
    switch (code) {
      case 'com.magenta.error.constraint_violation':
        strToReturn = i18n.t(
          'fleet_management.geofences.delete_geofence.errors.constraint_violation'
        )
        break
      case 'com.magenta.error.not_found':
        strToReturn = i18n.t(
          'fleet_management.geofences.delete_geofence.errors.not_found'
        )
        break
      case 'com.magenta.error.unexpected_error':
        strToReturn = i18n.t(
          'fleet_management.geofences.delete_geofence.errors.unexpected_error'
        )
        break
      default:
        strToReturn = i18n.t(
          'fleet_management.geofences.delete_geofence.errors.unexpected_error'
        )
        break
    }
    return strToReturn
  }
}
